import {registerRoot} from 'remotion';
import {RemotionRoot} from './Root.jsx';

registerRoot(RemotionRoot);
